import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  makeStyles
} from '@material-ui/core';

import Alert from '../common/alert';

const useStyles = makeStyles((theme) => ({
  head: {
    '& .MuiTableCell-head': {
      borderBottomColor: 'rgba(0,0,0,0.6)'
    }
  },
}));

const rowsPerPageOptions = [25, 50, 75, 100];

const UserReviewsList = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { items, noResultsMessage, rows = 50 } = props;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if(!items || !items.length) {
    if(noResultsMessage) {
      return (
        <Alert severity="info">{noResultsMessage}</Alert>
      );
    } else {
      return null;
    }
  }

  const visibleRows = items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const averageRating = items.reduce((a, b) => a + b.rating, 0) / items.length;
  const roundedAverage = Math.round(averageRating * 10) / 10; // 1 decimal

  return (
    <>
      <Typography gutterBottom><Trans t={t} i18nKey='userReviews:overallRating' values={{average: roundedAverage, amount: items.length}} components={[<strong key="strong" />]} /></Typography>
      <TableContainer>
        <Table>
          <TableHead className={classes.head}>
            <TableRow>
              <TableCell size="small"><Typography variant="overline">{t('userReviews:rating')}</Typography></TableCell>
              <TableCell size="small"><Typography variant="overline">{t('userReviews:username')}</Typography></TableCell>
              <TableCell size="small"><Typography variant="overline">{t('userReviews:date')}</Typography></TableCell>
              <TableCell size="small"><Typography variant="overline">{t('userReviews:title')}</Typography></TableCell>
              <TableCell size="small"><Typography variant="overline">{t('userReviews:comment')}</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.map(row => (
              <TableRow key={row.id}>
                <TableCell>{row.rating}</TableCell>
                <TableCell>{row.username}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.review}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                colSpan={6}
                count={items.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  )
};

UserReviewsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  noResultsMessage: PropTypes.string,
  rows: PropTypes.oneOf(rowsPerPageOptions)
};

export default UserReviewsList;
